import axiosInstance from "api/axiosInstance";

import type { PolicyOptionsResponse, ShippingPolicyFull, ShippingPolicyCreateRequest, ReturnExchangePolicyFull, ReturnExchangePolicyCreateRequest, AfterServicePolicyFull, AfterServicePolicyCreateRequest } from "api/types/policies.types";

const OPTIONS_URL = "/server/buccl_main/api/v1/admin/policies/options/";
const SHIPPING_BASE = "/server/buccl_main/api/v1/admin/policies/shipping/";
const RETURN_BASE = "/server/buccl_main/api/v1/admin/policies/return-exchange/";
const AS_BASE = "/server/buccl_main/api/v1/admin/policies/after-service/";

export const policiesService = {
  getOptions: () => axiosInstance.get<PolicyOptionsResponse>(OPTIONS_URL),

  // 배송 정책
  createShipping: (payload: ShippingPolicyCreateRequest) => axiosInstance.post<ShippingPolicyFull>(SHIPPING_BASE, payload),
  updateShipping: (id: number, payload: Partial<ShippingPolicyCreateRequest>) => axiosInstance.patch<ShippingPolicyFull>(`${SHIPPING_BASE}${id}/`, payload),
  deleteShipping: (id: number) => axiosInstance.delete(`${SHIPPING_BASE}${id}/`),

  // 반품/교환 정책
  createReturnExchange: (payload: ReturnExchangePolicyCreateRequest) => axiosInstance.post<ReturnExchangePolicyFull>(RETURN_BASE, payload),
  updateReturnExchange: (id: number, payload: Partial<ReturnExchangePolicyCreateRequest>) => axiosInstance.patch<ReturnExchangePolicyFull>(`${RETURN_BASE}${id}/`, payload),
  deleteReturnExchange: (id: number) => axiosInstance.delete(`${RETURN_BASE}${id}/`),

  // A/S 정책
  createAfterService: (payload: AfterServicePolicyCreateRequest) => axiosInstance.post<AfterServicePolicyFull>(AS_BASE, payload),
  updateAfterService: (id: number, payload: Partial<AfterServicePolicyCreateRequest>) => axiosInstance.patch<AfterServicePolicyFull>(`${AS_BASE}${id}/`, payload),
  deleteAfterService: (id: number) => axiosInstance.delete(`${AS_BASE}${id}/`),
};
